$(function(){
  moment.locale('ja');

  DateRangePicker();

  $('.date_text_field').daterangepicker({
    timePicker: false,
    timePicker24Hour: true,
    singleDatePicker: true,
    locale: {
      applyLabel: '適用する',
      cancelLabel: 'キャンセル',
      format: 'YYYY-MM-DD'
    }
  });

  $('.datetimepicker').daterangepicker({
    autoUpdateInput: false,
    timePicker: true,
    timePicker24Hour: true,
    timePickerIncrement: 1,
    singleDatePicker: true,
    locale: {
      applyLabel: '適用する',
      cancelLabel: 'キャンセル'
    }
  }, function(date) {
    $(this.element).val(date.format('YYYY-MM-DD HH:mm'));
  });

  $('.search_daterangepicker').daterangepicker({
    autoUpdateInput: false,
    singleDatePicker: false,
    locale: {
      applyLabel: '適用する',
      cancelLabel: 'キャンセル'
    }
  }, function(start, end) {
    $(this.element).val(start.format('YYYY/MM/DD') + ' ~ ' + end.format('YYYY/MM/DD'));
  });

  $('.datetimepicker').on('apply.daterangepicker', function(_ev, picker) {
    $(this).val(picker.startDate.format('YYYY-MM-DD HH:mm'));
  });

  if($('.search_daterangepicker').length){
    $('.search_daterangepicker').on('hide.daterangepicker', function(_ev, _picker) {
      Rails.fire($('.search_commit')[0], 'submit');
    });

    $('.search_daterangepicker').on('show.daterangepicker', function(_ev, picker) {
      if($('#date_range').val() == ''){
        picker.setStartDate(moment().format('YYYY/MM/DD'));
        picker.setEndDate(moment().format('YYYY/MM/DD'));
        picker.updateView();
      }
    });

    var btn = $('<button class="clearBtn btn btn-sm btn-primary" type="button">クリア</button>');
    $('.daterangepicker .drp-buttons').append(btn);
    $('.daterangepicker .drp-selected').addClass('selected-date');
    $('.daterangepicker .drp-buttons .applyBtn').on('click', function() {
      var input = $('.search_daterangepicker');
      if(input.val() == '') {
        var dates = input.data('daterangepicker');
        input.val(dates.startDate.format('YYYY/MM/DD') + ' ~ ' + dates.endDate.format('YYYY/MM/DD'));
      }
    });
    $('.daterangepicker .drp-buttons .clearBtn').on('click', function() {
      if($('#date_range').val() != ''){
        $('#date_range').val('');
      }
      $('.cancelBtn').trigger('click');
    });
  }
});

function DateRangePicker(){
  $('.datepicker').daterangepicker({
    autoUpdateInput: false,
    timePicker: false,
    timePicker24Hour: true,
    singleDatePicker: true,
    locale: {
      applyLabel: '適用する',
      cancelLabel: 'キャンセル'
    }
  }, function(date) {
    $(this.element).val(date.format('YYYY-MM-DD'));
  });

  $('.datepicker').on('apply.daterangepicker', function(_ev, picker) {
    $(this).val(picker.startDate.format('YYYY-MM-DD'));
  });
}

export { DateRangePicker }
